import { cn } from '@foam/buoy/src/lib/utils';
import { motion } from 'framer-motion';
import { useId, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'ui-components';

/**
 * this will be moved to UI library as a molecule, with Collapsible as an atom,
 * as a part of effort to create design system atoms & molecules for Filters and Drawers app-wide.
 *
 * currently blocked on ongoing css tooling effort by Prasanna
 */
export function CollapsibleDrawerSection({
  children,
  title,
  defaultOpen = false,
  className,
  ...rest
}: {
  children: React.ReactNode;
  title: string;
  /**
   * @default false
   *
   * no need for controlled mode
   *
   */
  defaultOpen?: boolean;
} & React.ComponentProps<'div'>) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const id = useId();

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const IconComponent = isOpen ? ChevronUpIcon : ChevronDownIcon;

  return (
    <div
      className={cn('py-1 px-4 bg-neutral-50 rounded-8', className)}
      {...rest}
    >
      <div className="flex items-center justify-between">
        <button
          onClick={toggleCollapse}
          aria-expanded={isOpen}
          aria-controls={id}
          type="button"
          className="flex w-full items-center justify-between gap-2"
        >
          <h3 className="py-2 text-16 font-500 uppercase leading-3 text-neutral-700">
            {title}
          </h3>
          <IconComponent className="shrink-0 text-neutral-700" boxSize={4} />
        </button>
      </div>
      <motion.div
        id={id}
        initial={false}
        className="min-h-0"
        animate={{
          height: isOpen ? 'auto' : '0',
          visibility: isOpen ? 'visible' : 'hidden',
          opacity: isOpen ? 1 : 0,
          marginTop: isOpen ? '1rem' : '0',
        }}
        transition={{
          duration: 0.25,
          ease: 'easeInOut',
        }}
        style={{
          pointerEvents: isOpen ? 'auto' : 'none',
        }}
        aria-hidden={!isOpen}
      >
        {children}
      </motion.div>
    </div>
  );
}
